import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainFooter",
  data() {
      return {
          user: {}, 
          user_slug: {}
      }
  }
 
}


// WEBPACK FOOTER //
// ./src/components/Main-Footer/script.js